// constants/routeMappings.js
export const ROUTE_MAPPINGS = {
  Analytics_and_report: "/app/dashboard",
  RBAC_Management: "/app/business/rbac-management",
  Operational_Setting: "/app/operational-setting",
  Store_Operations: "/app/operational-setting",
  Service_Configuration: "/app/service-configuration",
  Service_Area: "/app/service-area",
  Customer_Management: "/app/customer-management",
  Order_Management: "/app/order-management",
  Pricing_Tiers: "/app/pricing-tiers",
  Feedback_Management: "/app/feedback",
  "Promotions_&_Marketing": "/app/promotions&marketing",
  Inventory_Management: "/app/inventory"
};

export const ROUTE_MAPPINGS_ADMIN = {
  "User Management": "/app/user-management",
  "RBAC Management": "/app/rbac-management",
  "Approval Dashboard": "/app/approval-dashboard",
  "Service Settings": "/app/service-setting",
  "Configuration Settings": "/app/configuration-settings",
  "Dashboard": "/app/analytics-dashboard",
  "Customers": "/app/customers",
};
